var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagFinish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m21.297 6.348.23-.096c.093.356.198.802.334 1.377.16.677.363 1.532.637 2.628l.91 3.639a7.8 7.8 0 0 1-.333.184c-.26.138-.6.307-1.054.535-.876.438-1.42.648-1.895.759-.47.11-.924.135-1.658.135-.59 0-1.057-.086-1.669-.199l-.16-.03a13.957 13.957 0 0 0-2.668-.265c-1.645-.005-2.855.594-3.675 1.1l-2.16-8.098c.362-.18.797-.376 1.26-.547.745-.274 1.483-.456 2.072-.456.914 0 1.665.114 2.445.24l.098.015c.744.12 1.543.247 2.459.245 2.071-.004 3.646-.668 4.827-1.166ZM12.932 25.75l-2.088-7.604.128-.083c.794-.514 1.626-1.052 2.993-1.048a11.97 11.97 0 0 1 2.313.233l.174.032c.596.11 1.234.23 2.016.23.766 0 1.41-.024 2.113-.189.699-.163 1.405-.453 2.334-.917l.12-.06c.792-.396 1.354-.677 1.697-.926.202-.146.424-.347.571-.64.15-.299.165-.582.165-.764v-.123l-.03-.12-1-3.999c-.255-1.022-.46-1.882-.624-2.578a67.653 67.653 0 0 0-.362-1.485c-.098-.371-.205-.736-.348-1.003a1.38 1.38 0 0 0-.464-.524 1.145 1.145 0 0 0-.989-.121c-.503.167-.956.358-1.399.544-1.106.466-2.153.906-3.786.91-.752.001-1.41-.104-2.184-.228l-.053-.009c-.789-.126-1.675-.264-2.761-.264-.934 0-1.93.272-2.764.58-.848.313-1.611.694-2.105.978a1.196 1.196 0 0 0-.559 1.346l2.675 10.03.002.008 2.287 8.323a1 1 0 1 0 1.928-.53Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFinish);
export default __webpack_public_path__ + "static/media/flag-finish.bf169f240970adce24e99a5da25b8054.svg";
export { ForwardRef as ReactComponent };